/*
 * Single source of truth for the default (non-channel) pricing plans. Consumed
 * by src/components/sections/Pricing.js (default branch) and scripts/inject-seo.js
 * (SoftwareApplication Offer schema).
 *
 * CommonJS (module.exports) so the Node postbuild script and the React app
 * (webpack) can both consume it, same pattern as professions.js.
 *
 * Prices are pre-formatted strings. annualPriceMonthly is the annual price
 * divided by 12 and is the headline "$X / month" figure shown on the site.
 */
const PRICING_PLANS = [
  {
    name: 'Lite',
    description: 'Just the essentials',
    features: ['Unlock your building door', 'Get a local phone number', 'View activity history for 7 days'],
    missingFeatures: [
      'Share access with multiple users',
      'Create secure access codes',
      'Schedule access by time and day',
    ],
    monthlyPrice: '19.47',
    annualPrice: '137.97',
    annualPriceMonthly: '11.50',
    color: '#FFFFFF',
  },
  {
    name: 'Standard',
    description: 'Perfect for roommates and deliveries',
    features: [
      'Unlock your building door',
      'Get a local phone number',
      'Share access with up to 2 users',
      'View activity history for 30 days',
      'Create secure access codes',
    ],
    missingFeatures: ['Schedule access by time and day'],
    monthlyPrice: '19.87',
    annualPrice: '142.79',
    annualPriceMonthly: '11.90',
    color: '#FFFF64',
  },
  {
    name: 'Premium',
    description: 'Perfect for recurring home services',
    features: [
      'Unlock your building door',
      'Get a local phone number',
      'Share access with up to 8 users',
      'View unlimited activity history',
      'Create secure access codes',
      'Schedule access by time and day',
    ],
    missingFeatures: [],
    monthlyPrice: '35.89',
    annualPrice: '238.47',
    annualPriceMonthly: '19.87',
    color: '#41E1B0',
  },
  {
    name: 'Business',
    description: 'Ideal for businesses & property management',
    features: [
      'Everything included in Premium',
      'Manage multiple buildings from one account',
      'Use with multiple residential units',
      'Invite your team to manage buildings across devices',
      'Unlimited passcodes and routines',
    ],
    missingFeatures: [],
    monthlyPrice: '41.67',
    annualPrice: '500.00',
    annualPriceMonthly: '41.67',
    color: '#242a2d',
  },
];

module.exports = { PRICING_PLANS };
